import { S3_BUCKET_URL } from '@/constants';
import { LAYOUT_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';

export type CharacterFolder = 'maxim' | 'thomas';

const ASSETS_BASE_PATH = `${S3_BUCKET_URL}/layout-own-ai-man-tm`;

export const useCharacterFolder = () => {
  const layoutNotes = webCampaign.getLayoutNotes();

  const character: CharacterFolder = layoutNotes.includes(
    LAYOUT_NOTES.TM_THOMAS,
  )
    ? 'thomas'
    : 'maxim';

  const assetsPath = `${ASSETS_BASE_PATH}/${character}`;

  return {
    character,
    assetsPath,
    getAsset: (path: string) => `${assetsPath}/${path}`,
  };
};
